import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[customRender]',
})
export class CustomRenderDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
